import * as React from 'react'

import { HeaderView } from './Header.view'

export const Header = () => {
  return <HeaderView />
}
